<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.invoices_issuing.step1.new_admin_center_header') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div>
        <div class="form-wrapper p-4 overflow-x-auto overflow-y-auto">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-col"
          autocomplete="off">
          <div class="flex-1">
            <div class="flex flex-col lg:flex-row gap-x-6">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('sedes.entity_name') }}</label>
                <div class="flex justify-between">
                  <el-form-item prop="idSede" class="w-full">     
                    <el-select class="w-full" 
                      :value="selectValue"
                      :placeholder="$t('app.select')"
                      :loading="loadingSedes"
                      clearable
                      filterable
                      @input="onSelectSede">
                      <el-option-group v-for="sociedad in sociedadesSedes" :key="sociedad.IdSociedad" :label="`${sociedad.NameCorporateName} ${sociedad.FirstSurname || ''}`.trim()">
                        <el-option
                          v-for="opt in sociedad.Sedes"
                          :key="opt.IdSede"
                          :label="opt.LocationName"
                          :value="getOptionValue(opt.IdSede, sociedad.IdSociedad)">
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button mode="secondary-phantom-blue" class="w-full mx-2" :text="$t('invoices.invoices_issuing.step0.modal_continue')" @click="submitHandler('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'

import { getSociedadesSedesSimple } from '@/services/configurations/getSociedadesSedesSimple'

export default {
  /* eslint-disable camelcase */
  name: 'new-admin-center-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    idCliente: [Number, String],
    idCifEmpresa: {
      type: [Number, String],
      required: true
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: this.getDefaultForm(),
      loadingSedes: false,
      sociedadesSedes: [],
      rules: {
        idSociedad: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        idSede: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
      },
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    selectValue: function () {
      if (!this.form.idSede && !this.form.idSociedad) {
        return ''
      }
      return this.getOptionValue(this.form.idSede, this.form.idSociedad)
    }
  },
  watch: {
    dialogOpen: async function (value, oldValue) {
      if (value !== oldValue) {
        this.isOpen = !!value
        this.resetForm()
        if (this.isOpen) {
          this.sociedadesSedes = await this.getSociedadesSedes()
        }
      }
    }
  },
  methods: {
    getDefaultForm: function () {
      return {
        idSociedad: '',
        idSede: '',
      }
    },
    getOptionValue: function (idSede, idSociedad) {
      return JSON.stringify({ idSede, idSociedad })
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('toggleDialog')
    },
    resetForm () {
      this.form = this.getDefaultForm()
    },
    onSelectSede (jsonId) {
      const { idSede, idSociedad }=JSON.parse(jsonId)
      this.form.idSede = idSede
      this.form.idSociedad = idSociedad
    },
    submitHandler: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          } else {
            const params = {
              idSociedad: parseInt(this.form?.idSociedad),
              idSede: parseInt(this.form?.idSede)
            }
            this.goAdminCenterCreation(params)
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getSociedadesSedes: async function () {
      const params = { 
        idCifEmpresa: this.idCifEmpresa,
        idCliente: this.idCliente || null
      }
      const data = await getSociedadesSedesSimple(params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data.respuesta
    },
    goAdminCenterCreation: function (params) {
      this.$store.dispatch('app/enterMode', 1)
      this.$router.push({ 
        name: 'masters/society/locations/administrativecenters',
        params: { 
          id: params.idSociedad,
          idSede: params.idSede
        } 
      })
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}

</style>
